import { rateCardQuery } from "@common/api/rate-cards"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { RateCardDetailsForm } from "../-components/form/rate-card-details-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/rate-cards/$rateCardId",
)({
  staticData: { detailSidebar: true },
  loader: ({ context: { queryClient }, params: { rateCardId } }) =>
    queryClient.fetchQuery(rateCardQuery({ rate_card_id: rateCardId })),
  component: RateCardPanel,
})

function RateCardPanel(): React.ReactElement {
  const { rateCardId } = Route.useParams()
  const { data: card } = useSuspenseQuery(
    rateCardQuery({ rate_card_id: rateCardId }),
  )
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () =>
    navigate({ to: "/settings/quoting/rate-cards", search: true })

  return (
    <RateCardDetailsForm
      key={`${card.id}-${card.deleted_at}`}
      card={card}
      onRestore={() => showToast("Restored", "Record restored.", "success")}
      onSave={(saved) =>
        showToast("Saved", `${saved.name} updated.`, "success")
      }
      onClose={close}
    >
      <Outlet />
    </RateCardDetailsForm>
  )
}
